<ng-container *transloco="let t">
  <div class="main-content">
    <div class="data-section" id="data-section">
      <div class="title-row">
        <h3>{{ t(TITLE) }}</h3>
      </div>

      <div class="content-container">
        <div class="actions-row">
          <p-button
            [icon]="
              'pi pi-refresh' +
              (((dataLoading$ | async) ?? true) ? ' pi-spin' : '')
            "
            [disabled]="(dataLoading$ | async) ?? true"
            (click)="refreshData()"
          />

          <p-button
            icon="pi pi-filter"
            severity="info"
            [outlined]="!filtersDialogVisible"
            [disabled]="(dataLoading$ | async) ?? true"
            (click)="toggleFilters()"
            [label]="appliedFiltersCount"
          />

          <input
            #dataSearch
            type="text"
            pInputText
            id="search-input"
            (input)="dataTable.filterGlobal(dataSearch.value, 'contains')"
            [placeholder]="t(SEARCH_PLACEHOLDER)"
            class="search-input"
          />

          <p-button
            [label]="t(ADD_BUTTON_LABEL)"
            icon="pi pi-plus"
            class="add-record-button"
            (click)="openFormDialog()"
          />

          <p-button
            icon="pi pi-list-check"
            severity="secondary"
            [disabled]="selectedRows.length === 0"
            (click)="batchMenuElement.toggle($event)"
          />

          <p-menu
            #batchMenuElement
            [model]="batchMenu"
            [popup]="true"
            appendTo="body"
          />
        </div>

        <p-skeleton
          class="skeleton-loader"
          height="100%"
          width="100%"
          [class.visible]="(dataLoadingUI$ | async) ?? true"
        />

        <p-table
          #dataTable
          class="table"
          id="table"
          [value]="data"
          [(selection)]="selectedRows"
          [rowHover]="true"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[5, 10, 15, 20, 50]"
          sortMode="single"
          selectionMode="multiple"
          [rowTrackBy]="_dataTrackBy"
          [metaKeySelection]="true"
          [resizableColumns]="true"
          columnResizeMode="fit"
          [globalFilterFields]="dataFilterFields"
          stripedRows
          [scrollable]="true"
          [class.visible]="!((dataLoadingUI$ | async) ?? true)"
        >
          <ng-template #header>
            <tr>
              <th style="width: 3rem"><p-tableHeaderCheckbox /></th>

              @for (col of columns; track col.field) {
                @if (col.visible ?? true) {
                  <th [pSortableColumn]="col.field" pResizableColumn>
                    <div class="table-header-row">
                      <span class="header-label">{{
                        t(col.header, col.headerParams)
                      }}</span>
                      <div class="header-buttons">
                        <p-sortIcon [field]="col.field" />
                      </div>
                    </div>
                  </th>
                }
              }
            </tr>
          </ng-template>
          <ng-template #body let-record let-rowIndex="rowIndex">
            <tr
              [pSelectableRow]="record"
              [pSelectableRowIndex]="rowIndex"
              (contextmenu)="$event.preventDefault(); openFormDialog(record)"
              (longPress)="openFormDialog(record)"
              appLongPress
            >
              <td (click)="$event.stopPropagation()">
                <p-tableCheckbox [value]="record" />
              </td>
              @for (col of columns; track col.field) {
                @if (col.visible ?? true) {
                  <td>
                    <!-- CELLA -->
                    @if (col.wrapper) {
                      <ng-container
                        *ngComponentOutlet="
                          col.wrapper;
                          inputs: parseWrapperInputs(col, [
                            record,
                            getCellData(col, record),
                          ])
                        "
                      ></ng-container>
                    } @else {
                      <span [innerHTML]="getCellData(col, record)"></span>
                    }
                  </td>
                }
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <!--? FORM DIALOG  --------------------------------->
  <p-dialog
    [header]="
      isNewRecordDialog
        ? t(NEW_RECORD_TITLE)
        : t(EDIT_RECORD_TITLE, { code: formDialogData.code })
    "
    [modal]="true"
    [(visible)]="formDialogVisible"
    [style]="{ width: 'min(35rem, 90vw)' }"
    [maximizable]="false"
    [draggable]="false"
    appendTo="body"
    [focusOnShow]="true"
    [dismissableMask]="false"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
    styleClass="form-dialog"
    (onHide)="onHideFormDialog(dialogForm)"
  >
    <form class="dialog-form" #dialogForm="ngForm">
      <!--? CODE ----------------------------->
      <p-floatlabel variant="in">
        <input
          #bikeModelCodeInput="ngModel"
          pInputText
          id="model-code-input"
          name="code"
          [(ngModel)]="formDialogData.code"
          autocomplete="off"
          required
          [disabled]="(dataLoading$ | async) ?? true"
        />
        <label for="model-code-input">
          {{ t("code") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? NAME ----------------------------->
      <p-floatlabel variant="in">
        <input
          #bikeModelDescriptionInput="ngModel"
          pInputText
          id="model-description-input"
          name="description"
          [(ngModel)]="formDialogData.description"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          required
        />
        <label for="model-description-input">
          {{ t("description") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? TARIFF PLANS ---------------------------->
      <p-floatlabel variant="in">
        <p-multiselect
          #bikeModelPlansInput="ngModel"
          inputId="model-plan-input"
          name="tariffPlans"
          [(ngModel)]="formDialogData.tariffPlans"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          [options]="tariffPlans"
          optionLabel="code"
          optionValue="planId"
          appendTo="body"
          styleClass="w-full"
        />
        <label for="model-plan-input">
          {{ t("tariffPlans") }}
        </label>
      </p-floatlabel>

      <!--? MAX DISTANCE --------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #bikeModelMaxDistanceInput="ngModel"
          inputId="model-maxDistance-input"
          name="maxDistance"
          [(ngModel)]="formDialogData.maxDistance"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          [allowEmpty]="true"
          [min]="0"
          [showButtons]="true"
        />
        <label for="model-maxDistance-input">
          {{ t("maxDistanceUom", { uom: "km" }) }}
        </label>
      </p-floatlabel>

      <!--? MAX SPEED ------------------------>
      <p-floatlabel variant="in">
        <p-inputnumber
          #bikeModelMaxSpeedInput="ngModel"
          inputId="model-maxSpeed-input"
          name="maxSpeed"
          [(ngModel)]="formDialogData.maxSpeed"
          autocomplete="off"
          [disabled]="(dataLoading$ | async) ?? true"
          [allowEmpty]="true"
          [min]="0"
          [showButtons]="true"
        />
        <label for="model-maxSpeed-input">
          {{ t("maxSpeedUom", { uom: "km/h" }) }}
        </label>
      </p-floatlabel>

      <!--? PICTURES ------------------------->
      <div class="pictures-row">
        <label
          for="model-main-picture-input"
          class="picture-input-label"
          [class.filled]="
            fileState.mainPicturePreview || fileState.mainPictureFile
          "
          [pTooltip]="t('mainPicture')"
          [showDelay]="300"
          tooltipPosition="top"
        >
          @if (fileState.mainPicturePreview) {
            <img
              [src]="fileState.mainPicturePreview"
              [alt]="t('mainPicture')"
            />
          } @else {
            <span class="material-symbols-outlined placeholder-icon">
              image
            </span>
          }

          @if (fileState.mainPicturePreview || fileState.mainPictureFile) {
            <span
              class="material-symbols-outlined delete-icon"
              (click)="$event.preventDefault(); clearImage('mainPicture')"
            >
              delete
            </span>
          }

          @if (fileState.mainPictureFile) {
            <div
              class="to-upload-badge"
              [pTooltip]="t('toUpload')"
              [showDelay]="300"
            >
              <span class="material-symbols-outlined icon"> upload </span>
            </div>
          }
        </label>
        <input
          type="file"
          id="model-main-picture-input"
          accept="image/*"
          class="hidden-input"
          name="mainPicture"
          (change)="onFileSelected($event, 'mainPicture')"
        />

        <label
          for="model-2-picture-input"
          class="picture-input-label"
          [class.filled]="fileState.picture2Preview || fileState.picture2File"
          [pTooltip]="t('picture2')"
          [showDelay]="300"
          tooltipPosition="top"
        >
          @if (fileState.picture2Preview) {
            <img [src]="fileState.picture2Preview" [alt]="t('picture2')" />
          } @else {
            <span class="material-symbols-outlined placeholder-icon">
              filter_2
            </span>
          }

          @if (fileState.picture2Preview || fileState.picture2File) {
            <span
              class="material-symbols-outlined delete-icon"
              (click)="$event.preventDefault(); clearImage('picture2')"
            >
              delete
            </span>
          }

          @if (fileState.picture2File) {
            <div
              class="to-upload-badge"
              [pTooltip]="t('toUpload')"
              [showDelay]="300"
            >
              <span class="material-symbols-outlined icon"> upload </span>
            </div>
          }
        </label>
        <input
          type="file"
          id="model-2-picture-input"
          accept="image/*"
          class="hidden-input"
          name="picture2"
          (change)="onFileSelected($event, 'picture2')"
        />

        <label
          for="model-3-picture-input"
          class="picture-input-label"
          [class.filled]="fileState.picture3Preview || fileState.picture3File"
          [pTooltip]="t('picture3')"
          [showDelay]="300"
          tooltipPosition="top"
        >
          @if (fileState.picture3Preview) {
            <img [src]="fileState.picture3Preview" [alt]="t('picture3')" />
          } @else {
            <span class="material-symbols-outlined placeholder-icon">
              filter_3
            </span>
          }

          @if (fileState.picture3Preview || fileState.picture3File) {
            <span
              class="material-symbols-outlined delete-icon"
              (click)="$event.preventDefault(); clearImage('picture3')"
            >
              delete
            </span>
          }

          @if (fileState.picture3File) {
            <div
              class="to-upload-badge"
              [pTooltip]="t('toUpload')"
              [showDelay]="300"
            >
              <span class="material-symbols-outlined icon"> upload </span>
            </div>
          }
        </label>
        <input
          type="file"
          id="model-3-picture-input"
          accept="image/*"
          class="hidden-input"
          name="picture3"
          (change)="onFileSelected($event, 'picture3')"
        />
      </div>
      <p class="pictures-suggestion-label">
        {{ t("modelPicturesSuggestion") }}
      </p>
    </form>

    <ng-template #footer>
      @if (!isNewRecordDialog) {
        <p-button
          [label]="t('delete')"
          severity="danger"
          (click)="deleteRecord()"
          class="delete-button"
          [outlined]="true"
          [disabled]="(dataLoading$ | async) ?? true"
        />
      }
      <p-button
        [label]="t('cancel')"
        severity="secondary"
        (click)="hideFormDialog(dialogForm)"
        [outlined]="true"
      />
      <p-button
        [label]="t('save')"
        severity="primary"
        (click)="saveRecord()"
        [disabled]="((dataLoading$ | async) ?? true) || !dialogForm.valid"
      />
    </ng-template>
  </p-dialog>

  <!--? FILTERS DIALOG --------------------------------->
  <p-dialog
    [header]="t(FILTERS_TITLE)"
    [(visible)]="filtersDialogVisible"
    [style]="{
      width: 'min(30rem, 80vw)',
      'min-width': '430px',
      'max-width': '90vw',
      'max-height': '90vh',
      'min-height': '10rem',
    }"
    [maximizable]="false"
    [draggable]="true"
    appendTo="body"
    styleClass="filter-dialog"
    (onHide)="onFiltersDialogHide()"
  >
    <form class="filter-form" #filterForm="ngForm">
      <!--? MAX DISTANCE ----------------------------->
      <div class="slider-float-label">
        <label for="bike-model-filter-maxDistance">
          {{ t("maxDistance") }}
        </label>
        <div class="field-cont">
          <p-checkbox
            [(ngModel)]="isMaxDistanceFilterEnabled"
            [binary]="true"
            class="filter-checkbox"
            (onChange)="onFilterToggle('maxDistance')"
            #bikeModelMaxDistanceCheckbox="ngModel"
            name="bike-model-filter-maxDistance-checkbox"
          />
          <div
            class="slider-cont"
            [class.disabled]="!isMaxDistanceFilterEnabled"
          >
            <span class="limit-label">{{
              dataFilters.values.maxDistance?.[0] ??
                dataFilters.options.minDistance
            }}</span>
            <p-slider
              #bikeModelMaxDistanceInput="ngModel"
              inputId="bike-model-filter-maxDistance"
              name="bike-model-filter-maxDistance"
              styleClass="w-full"
              [(ngModel)]="dataFilters.values.maxDistance"
              [range]="true"
              [min]="dataFilters.options.minDistance"
              [max]="dataFilters.options.maxDistance"
              [step]="1"
              [disabled]="!isMaxDistanceFilterEnabled"
            ></p-slider>
            <span class="limit-label">{{
              dataFilters.values.maxDistance?.[1] ??
                dataFilters.options.maxDistance
            }}</span>
          </div>
        </div>
      </div>

      <!--? MAX SPEED ----------------------------->
      <div class="slider-float-label">
        <label for="bike-model-filter-maxSpeed">
          {{ t("maxSpeed") }}
        </label>
        <div class="field-cont">
          <p-checkbox
            [(ngModel)]="isMaxSpeedFilterEnabled"
            [binary]="true"
            class="filter-checkbox"
            (onChange)="onFilterToggle('maxSpeed')"
            #bikeModelMaxSpeedCheckbox="ngModel"
            name="bike-model-filter-maxSpeed-checkbox"
          />

          <div class="slider-cont" [class.disabled]="!isMaxSpeedFilterEnabled">
            <span class="limit-label">{{
              dataFilters.values.maxSpeed?.[0] ?? dataFilters.options.minSpeed
            }}</span>
            <p-slider
              #bikeModelMaxSpeedInput="ngModel"
              inputId="bike-model-filter-maxSpeed"
              name="bike-model-filter-maxSpeed"
              styleClass="w-full"
              [(ngModel)]="dataFilters.values.maxSpeed"
              [range]="true"
              [min]="dataFilters.options.minSpeed"
              [max]="dataFilters.options.maxSpeed"
              [step]="1"
              [disabled]="!isMaxSpeedFilterEnabled"
            ></p-slider>
            <span class="limit-label">{{
              dataFilters.values.maxSpeed?.[1] ?? dataFilters.options.maxSpeed
            }}</span>
          </div>
        </div>
      </div>
    </form>

    <ng-template #footer>
      <p-button
        [label]="t('clear')"
        severity="danger"
        [outlined]="true"
        (click)="resetFilters(); refreshData()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
      <p-button
        [label]="t('apply')"
        severity="primary"
        (click)="refreshData()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
    </ng-template>
  </p-dialog>
</ng-container>
